<template lang="pug">
  .events__tab-content-item
    .events__tab-content-title
      | {{item.title}}
    .events__tab-content-dates
      .events__tab-content-date(v-for="day in item.items", :key="day.id", v-on:click="popupLocal('event', 'show', day.id)" v-on:mouseenter="setImg(day.id, type)")
        .events__tab-content-day
          | {{day.date}}
        .events__tab-content-time-wr
          .events__tab-content-time
            | {{day.time}}
          .events__tab-content-time-text
            | {{day.text}}

</template>

<script>
  import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

  export default {
    name: "EventItem",

    mixins: [PopupHelpersVue],

    props: {
      item: {
        type: Object,
        required: true
      },
      setImg: {
        type: Function,
        required: true
      },
      type: {
        type: String,
        required: true
      }
    },

    components: {

    },

    methods: {
      popupLocal(type, action, id) {
        // сейчас идишник приходит/уходит для попапа события один и тот же, на проде будет уникальный
        this.popup(type, action, id);
      }
    }
  }
</script>
